import React from "react";

export default function Loading() {
    return <p><i>Loading...</i></p>;
};